import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExcRestService} from 'exc-rest-v2';
import {EnumerationService} from '../../../../services/enumeration.service';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import {ExcSecurityService} from 'exc-security-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ApplicationService} from '../../../../services/application.service';

@Component({
  selector: 'app-sv-user-dispositionsettings',
  templateUrl: './sv-user-dispositionsettings.component.html',
  styles: []
})
export class SvUserDispositionsettingsComponent extends ExcTranslation implements OnInit {
  private _data: any;

  @Input()
  set data(value: any) {
    this._data = value;
    this.reload();
  }
  get data(): any {
    return this._data;
  }

  userType: number | any;
  listDefinition: {
    ID: string,
    Exclude: boolean,
    Entity: string,
    FieldName: string,
    FieldType: string,
    ListType: string,
    DataSource: any[],
    Selected: any[],
    UnSelected: any[]
  }[] = [];
  absenceDefinition: { ID: string, Exclude: boolean, ListType: string, DataSource: any[] } = {
    ID: '',
    Exclude: false,
    ListType: 'ABSENCE',
    DataSource: []
  };
  routeDefinition: { ID: string, Exclude: boolean, ListType: string, DataSource: any[] } = {
    ID: '',
    Exclude: false,
    ListType: 'ROUTE',
    DataSource: []
  };
  capacityDefinition: {ID: string, Exclude: boolean, ListType: string, DataSource: any} = {
    ID: '', Exclude: false, ListType: 'Capacity', DataSource: {usr: 0, adm: 0, usrweek: 0, admweek: 0}
  };
  backupDefinition: {
   ID: string,
   isBackup: boolean
  } = { ID: '', isBackup: false};
  settings: any;
  isLoading = true;

  constructor(
    private excRest: ExcRestService,
    public enumSvc: EnumerationService,
    public excSecurity: ExcSecurityService,
    public modalSvc: ExgModalService,
    private appSvc: ApplicationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.userType = Number(this.appSvc.UserAttributes()?.type) || 2;
  }

  reload(): void {
    if (this._data && this._data.oeID) {
      this.isLoading = true;
      this.excRest.get(this.excRest.computeUrl('Dispositionsettings'
        , {oeID: this._data.oeID})).subscribe((e: any) => {
        this.settings = e.data.DispositionListDefinition;
        this.listDefinition = [];
        for (const o of e.data.DispositionListDefinition) {
          if (o.ldefListDefinitionType === 'BLACKLIST' || o.ldefListDefinitionType === 'WHITELIST') {
            const listDefintionItem: any = {
              ID: o.ldefID,
              Exclude: o.ldefExclude,
              Entity: o.ldefEntity,
              FieldName: o.ldefFieldName,
              FieldType: o.ldefFieldType,
              ListType: o.ldefListDefinitionType
            };
            switch (listDefintionItem.FieldType) {
              case 'Enumeration': {
                listDefintionItem.DataSource = this.enumSvc.getEnumerationList(o.ldefEnumName).map(enumeration => {
                  return {value: String(enumeration.enmIdent).toLowerCase(), caption: enumeration.enmText};
                });
                break;
              }
              case 'OE': {
                listDefintionItem.DataSource = e.data.OEList.map((oe: any) => {
                  return {value: String(oe.oeID).toLowerCase(), caption: oe.oeNPraefix};
                });
                break;
              }
              default:
                break;
            }

            const parsedValues: string[] = o.lvalValue != null ? JSON.parse(o.lvalValue.toLowerCase()) : null;
            listDefintionItem.Selected = parsedValues == null &&
            listDefintionItem.ListType === 'BLACKLIST'
              ? [...listDefintionItem.DataSource]
              : listDefintionItem.DataSource.filter((a: any) => (parsedValues ?? []).includes(a.value));
            listDefintionItem.UnSelected = parsedValues == null &&
            listDefintionItem.ListType === 'BLACKLIST'
              ? []
              : listDefintionItem.DataSource.filter((a: any) => !(parsedValues ?? []).includes(a.value));


            this.listDefinition.push(listDefintionItem);
          }
          if (o.ldefListDefinitionType === 'ABSENCE') {
            this.absenceDefinition.ID = o.ldefID;
            this.absenceDefinition.DataSource = JSON.parse(o.lvalValue ?? '[]')
              .sort((a: any, b: any) => a.from > b.from ? -1 : 1);
          }
          if (o.ldefListDefinitionType === 'ROUTE') {
            this.routeDefinition.ID = o.ldefID;
            this.routeDefinition.DataSource = JSON.parse(o.lvalValue ?? '[]');
          }
          if (o.ldefListDefinitionType === 'BACKUP') {
            this.backupDefinition.ID = o.ldefID;
            this.backupDefinition.isBackup = o.lvalValue === 'true';
          }
          if (o.ldefListDefinitionType === 'CAPACITY'){
            this.capacityDefinition.ID = o.ldefID;
            if (o.lvalValue != null && o.lvalValue !== '[]') {
              this.capacityDefinition.DataSource = JSON.parse(o.lvalValue);
            }
            else
            {
              this.capacityDefinition.DataSource = {usr: 0, adm: 0, usrweek: 0, admweek: 0};
            }
          }
        }
        this.isLoading = false;
      });
    }
  }

  drop(event: CdkDragDrop<string[]>): void {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
      this.save();
    }
  }

  save(): void {
    const putObject = [];

    for (const o of this.listDefinition) {
      const listValueArray: string[] = [];
      for (const value of o.Selected) {
        listValueArray.push(String(value.value));
      }
      putObject.push({
        ID: o.ID,
        Value: JSON.stringify(listValueArray)});
    }
    putObject.push({
      ID: this.absenceDefinition.ID,
      Value: JSON.stringify(this.absenceDefinition.DataSource)
    });
    putObject.push({
      ID: this.routeDefinition.ID,
      Value: JSON.stringify(this.routeDefinition.DataSource)
    });
    putObject.push({
      ID: this.capacityDefinition.ID,
      Value: JSON.stringify(this.capacityDefinition.DataSource)
    });
    if (this.backupDefinition.ID) {
      putObject.push({
        ID: this.backupDefinition.ID,
        Value: String(this.backupDefinition.isBackup)
      });
    }

    this.excRest.sput(
      this.excRest.computeUrl('Dispositionsettings',
        {oeID: this._data.oeID}
      ),
      putObject,
      'saveLists'
      ).subscribe((response: any) => {

      });
  }

  createAbsenceItem(): void {
    this.modalSvc.show(
      'ModalAbsencePickerComponent',
      undefined
    ).subscribe((res: any) => {
      if (res) {
        this.absenceDefinition.DataSource.push(res);
        this.save();
      }
    });
  }

  editAbsenceItem(index: number): void {
    if (this.canEditAbsence(index)) {
        this.modalSvc.show(
        'ModalAbsencePickerComponent',
        this.absenceDefinition.DataSource[index]
      ).subscribe((res: any) => {
        if (res) {
          this.absenceDefinition.DataSource[index] = res;
          this.save();
        }
      });
    }
  }

  deleteAbsenceItem(abs: any): void {
    if (this.canEditAbsence(0, abs)) {
      this.modalSvc
        .showSimple(
          this.getRessource('DeleteTitle') + '!',
          this.getResource('DeleteMassage'),
          true, true,
          this.getGlobal('Delete'),
          this.getGlobal('Reject'))
        .subscribe((ret: boolean) => {
          if (ret) {
            this.absenceDefinition.DataSource = this.absenceDefinition.DataSource
              .filter(absence => absence !== abs);
            this.save();
          }
        });
    }
  }

  canEditAbsence(index: number, abs?: any): boolean {
    const absenceItem = abs ? abs : this.absenceDefinition.DataSource[index];
    const fromData = new Date(absenceItem.from as string);

    return this.userType === 1 || (this.userType === 2 && !(fromData <= new Date()));
  }

  createRegioRouteItem(): void {
    this.modalSvc.show(
      'ModalRegionRouteEditorComponent',
      undefined
    ).subscribe((res: any) => {
      if (res) {
        this.routeDefinition.DataSource.push(res);
        this.save();
      }
    });
  }

  editRouteItem(index: number): void {
    if (this.canEditRouteEdit(index)) {
      this.modalSvc.show(
        'ModalRegionRouteEditorComponent',
        this.routeDefinition.DataSource[index]
      ).subscribe((res: any) => {
        if (res) {
          this.routeDefinition.DataSource[index] = res;
          this.save();
        }
      });
    }
  }

  deleteRouteItem(route: any): void {
    if (this.canEditRouteEdit(0, route)) {
      this.modalSvc
        .showSimple(
          this.getRessource('DeleteTitle') + '!',
          this.getResource('DeleteMassage'),
          true,
          true,
          this.getGlobal('Delete'),
          this.getGlobal('Reject')
        )
        .subscribe((ret: boolean) => {
          if (ret) {
            this.routeDefinition.DataSource =
              this.routeDefinition.DataSource
                .filter(routeSource => routeSource !== route);
            this.save();
          }
        });
      }
  }

  canEditRouteEdit(index: number, route?: any): boolean {
    const routeItem = route ? route : this.routeDefinition.DataSource[index];
    const toDate = new Date(routeItem.to as string);

    return this.userType === 1 || (this.userType === 2 && !(toDate <= new Date()));
  }

  capacityChange(field: string, value: any): void {
    this.capacityDefinition.DataSource[field] = value;
    this.save();
  }
}
